import Leaders from '@mindful-web/marko-web-leaders/browser';
import MonoRail from '@mindful-web/marko-web-theme-monorail/browser';

const DynamicSiteMenuPositioner = () => import(/* webpackChunkName: "dynamic-site-menu-positioner" */ './dynamic-site-menu-positioner.vue');

export default (Browser) => {
  Leaders(Browser);
  MonoRail(Browser);
  Browser.register('DynamicSiteMenuPositioner', DynamicSiteMenuPositioner);
};
